import { FaFacebook, FaLinkedin, FaDiscord } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "components/ui";

const linkClass = "text-sm text-ink-3 transition-colors hover:text-ink";
const headingClass = "text-xs font-semibold tracking-wider uppercase text-ink";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t bg-canvas-subtle border-line">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 py-12 gap-x-6 gap-y-10 sm:py-16 md:grid-cols-12 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-5 lg:col-span-6">
            <Link to={"/"} className="inline-flex" aria-label="Zamplia Surveys home">
              <BrandLogo className="w-auto h-8 sm:h-9" />
            </Link>
            <div className="flex items-center gap-1 mt-6 -ml-2">
              <a
                href="https://www.facebook.com/zampliasurveys"
                data-testid="Facebook"
                aria-label="Facebook"
                className="zs-icon-btn"
              >
                <FaFacebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/zamplia.surveys/"
                data-testid="Instagram"
                aria-label="Instagram"
                className="zs-icon-btn"
              >
                <AiFillInstagram size={20} />
              </a>
              <a href="https://www.linkedin.com/company/zamplia/" aria-label="LinkedIn" className="zs-icon-btn">
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="md:col-span-3 lg:col-span-3">
            <p className={headingClass}>{t("footer.Company")}</p>
            <ul className="mt-4 space-y-3">
              <li>
                <a className={linkClass} href="/#about">
                  {t("home.header.About")}
                </a>
              </li>
              <li>
                <a className={linkClass} href="/#faq">
                  {t("home.header.FAQ")}
                </a>
              </li>
              <li>
                <a className={linkClass} href="/#contact">
                  {t("home.footers.Contact")}
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div className="md:col-span-4 lg:col-span-3">
            <p className={headingClass}>{t("footer.Community")}</p>
            <ul className="mt-4 space-y-3">
              <li>
                <a className={linkClass} href="/">
                  {t("footer.Blog")}
                </a>
              </li>
              <li>
                <a className={linkClass} href="/">
                  {t("footer.Forum")}
                </a>
              </li>
              <li className="pt-1">
                <button className="zs-btn zs-btn-secondary zs-btn-sm">
                  <FaDiscord size={16} aria-hidden="true" />
                  {t("footer.discord.server")}
                  <FiArrowUpRight aria-hidden="true" />
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col gap-4 py-6 border-t border-line sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-ink-3">{t("footer.copywrite")}</p>
          <nav aria-label={t("footer.Important Links")} className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a className={linkClass} href="/privacy-policy" data-testid="PrivacyPolicy">
              {t("home.footer.PrivacyPolicy")}
            </a>
            <a className={linkClass} href="/terms-and-conditions" data-testid="TermsAndConditions">
              {t("home.footer.TermConditions")}
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
